import type { FC } from 'react';
import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';

export interface ChildrenLoadingIndicatorProps {
  onMount: (...params: any[]) => any;
}

const ChildrenLoadingIndicator: FC<ChildrenLoadingIndicatorProps> = ({
  onMount,
}) => {
  useEffect(() => {
    onMount();
  }, []);

  return <CircularProgress size={20} />;
};

export default ChildrenLoadingIndicator;
